module.exports = __webpack_public_path__ + "img/40_69_003_150.6955da9b.jpg";